var React = require('react');
var Modal = require('react-bootstrap').Modal;
var Button = require('react-bootstrap').Button;
var Row = require('react-bootstrap').Row;
var Col = require('react-bootstrap').Col;
var ButtonLink = require('react-router-bootstrap').ButtonLink;
var Access = require('./Access');

var Loading = require('../Loading');
var ServiceActions = require('../../actions/ServiceActions');
var ClientServiceStore = require('../../stores/ClientServiceStore');
var ContactStore = require('../../stores/ContactStore');
var UserStore = require('../../stores/UserStore');
var AccessSelector = require('./AccessSelector');
var Invocation = require('../../api/Invocation');
var ClientStore = require('../../stores/ClientStore');

function getState(props) {
  return {
    client: ClientStore.get(),
    rel: ContactStore.getRelFor(props.params.id),
    loading: ContactStore.loading(),
    working: ContactStore._working,
  }
}

var AccessManage = React.createClass({
  contextTypes: {
    router: React.PropTypes.func
  },
  componentDidMount: function() {
    ClientStore.addChangeListener(this.update);
    ContactStore.addChangeListener(this.update);
    UserStore.addChangeListener(this.update);
  },
  componentWillMount: function () {
    this.update()

    var user = UserStore.getUser();

    if (user && !ClientServiceStore.has() && !ClientServiceStore.loading()) {
      ServiceActions.getServices(user);
    }
  },
  componentWillUnmount: function () {
    ClientStore.removeChangeListener(this.update);
    ContactStore.removeChangeListener(this.update);
    UserStore.removeChangeListener(this.update);
  },
  componentWillReceiveProps: function (nextProps) {
    this.setState(getState(nextProps))

  },
  handleDeauth: function () {
    Invocation.auth
      .deauth(
        this.state.rel.client_id,
        this.state.rel.user.email,
        this.refs.replacementSelect.getDOMNode().value
      )
      .then(() => this.context.router.transitionTo('access'))
  },
  handleModify: function () {
    const roles = this.refs.roleSelector.getRoles()

    Invocation.auth
      .modifyAuth(this.state.rel.client_id, this.state.rel.user.email, roles)
      .then(() => this.context.router.transitionTo('access'))
  },
  update: function () {
    this.setState(getState(this.props))
  },
  render: function () {
    let replacements = []
    if (this.state.client && this.state.rel) {
      replacements = this.state.client.relationships
        .filter(rel => rel.user.email !== this.state.rel.user.email)
        .map(rel => [rel.user.email, rel.user.first_name + rel.user.last_name])
    }

    return (
      <div>
        <Access />

        <Modal
          animation={false}
          onHide={() => this.context.router.transitionTo('access')}
          show
        >
          <div className="modal-header">
            <h4>Manage Access for {this.state.rel ? (this.state.rel.user.first_name + this.state.rel.user.last_name) : <Loading />}</h4>
          </div>
          <div className="modal-body">
            <Row>
              <Col sm={6}>
                {this.state.rel && (
                  <AccessSelector
                    ref="roleSelector"
                    roles={this.state.rel.roles}
                    showPartner={this.state.client && !!this.state.client.partner}
                  />
                )}
                {!this.state.rel && (
                  <Loading />
                )}
              </Col>
              <Col sm={6}>
                {this.state.rel && (
                  <div>
                    <p>
                      To remove {this.state.rel.user.first_name} {this.state.rel.user.last_name}, please select a user
                      who will replace them if they are a primary contact anywhere
                      on this account.
                    </p>

                    <div className="form-group">
                      <label className="control-label">Replacement User</label>
                      <select className="form-control" ref="replacementSelect">
                        {replacements.map(replacement => (
                          <option key={replacement[0]} value={replacement[0]}>
                            {replacement[1]}
                          </option>
                        ))}
                      </select>
                    </div>

                    <Button className="pull-left" bsStyle="danger" onClick={this.handleDeauth}>
                      {this.state.working === 'DEAUTH' && (
                        <span><i className="fa fa-spinner fa-spin"></i> </span>
                      )}
                      Remove Access
                    </Button>
                  </div>
                )}
              </Col>
            </Row>
          </div>
          <div className="modal-footer">
            <ButtonLink to="access">Close</ButtonLink>
            <Button to="access" bsStyle="success" onClick={this.handleModify}>
              {this.state.working === 'MODIFY_AUTH' && (
                <span><i className="fa fa-spinner fa-spin"></i> </span>
              )}
              Update
            </Button>
          </div>
        </Modal>
      </div>
    );
  }
})
module.exports = AccessManage;



// WEBPACK FOOTER //
// ./app/components/Access/AccessManage.js